import { useAppDispatch } from '@core/redux/hooks';
import {
  getRememberEmailFromStorage,
  retriveLoginEmailFromStorage,
} from '@features/auth/store/auth.storage';
import { tryLogin } from '@features/auth/store/auth.thunk';
import { auth } from '@service/api';
import { Login } from '@templates';
import { Card, Space, Typography } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import * as S from './Login.style';

const { Title, Text } = Typography;

export const LoginPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from ?? { pathname: '/' };
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [hasStoredEmail, setHasStoredEmail] = useState(false);

  const onPressLogin = useCallback(
    async (credentials: auth.Credentials) => {
      setIsLoading(true);
      const response = await dispatch(tryLogin(credentials));
      if (tryLogin.fulfilled.match(response)) {
        navigate(from, { replace: true });
      }
      setIsLoading(false);
    },
    [dispatch, navigate, from]
  );

  useEffect(() => {
    const shouldRemember = getRememberEmailFromStorage();
    const storedEmail = retriveLoginEmailFromStorage();
    setHasStoredEmail(shouldRemember && storedEmail.length > 0);
  }, []);

  return (
    <S.Container>
      <S.RightCol span={22}>
        <S.FormContainer>
          <Card
            variant='borderless'
            style={{
              backgroundColor: 'transparent',
              boxShadow: 'none',
            }}
          >
            <S.Header>
              <S.LogoWrapper>
                <S.BrandLogo style={{ marginBottom: 40 }} />
              </S.LogoWrapper>
              <Space
                direction='vertical'
                size='small'
                style={{ width: '100%', textAlign: 'center' }}
              >
                <Title
                  level={3}
                  style={{ color: '#fff', margin: 0, fontWeight: 600 }}
                >
                  {hasStoredEmail ? 'Bem-vindo de volta' : 'Bem-vindo'}
                </Title>
                <Text
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '16px',
                  }}
                >
                  Faça login em sua conta
                </Text>
              </Space>
            </S.Header>
            <Login.LoginForm onLogin={onPressLogin} isLoading={isLoading} />
          </Card>
        </S.FormContainer>
      </S.RightCol>
    </S.Container>
  );
};
